<template>
<section>
  <form
    :class="{'filters--with-areas': areas.length}"
    class="filters"
  >
    <div class="filters__block">
      <span class="filters__icon">🌍</span>
      <select
        v-model="country"
        class="filters__input"
        @change="countryChanged"
      >
        <option value="">Worldwide</option>
        <option
          v-for="country of countries"
          :key="country.name"
          :value="country.name"
        >
          {{ country.name }}
        </option>
      </select>
    </div>
    <div class="filters__block">
      <span class="filters__icon">📌</span>
      <select
        v-model="city"
        :disabled="!country"
        class="filters__input"
        @change="cityChanged"
      >
        <option
          v-if="country"
          value=""
        >
          All regions
        </option>
        <option
          v-else
          value=""
        >
          -
        </option>
        <option
          v-for="city of cities"
          :key="city"
          :value="city"
        >
          {{ city }}
        </option>
      </select>
    </div>
    <div
      v-if="areas.length"
      class="filters__block"
    >
      <span class="filters__icon">🌇</span>
      <select
        v-model="area"
        class="filters__input"
        @change="filtersChanged"
      >
        <option
          value=""
        >
          All cities and towns
        </option>
        <option
          v-for="area of areas"
          :key="area"
          :value="area"
        >
          {{ area }}
        </option>
      </select>
    </div>
    <div class="filters__block">
      <span class="filters__icon">🗾</span>
      <select
        v-model="server"
        class="filters__input"
        @change="filtersChanged"
      >
        <option value="">All servers</option>
        <option
          v-for="server of servers"
          :key="server.value"
          :value="server.value"
        >{{ server.name }}</option>
      </select>
    </div>
  </form>
</section>
</template>

<script>
import { db } from '@/main'
import { servers } from '../constants'
import router from '@/router/index'

export default {
  name: 'Filters',

  data() {
    return {
      servers,
      countries: [],
      cities: [],
      areas: [],
      server: '',
      country: '',
      city: '',
      area: ''
    }
  },

  async created() {
    const paramCountry = this.$route.query.country && decodeURIComponent(this.$route.query.country)
    const paramCity = this.$route.query.region && decodeURIComponent(this.$route.query.region)
    const paramArea = this.$route.query.area && decodeURIComponent(this.$route.query.area)
    const paramServer = this.$route.query.server && decodeURIComponent(this.$route.query.server)
    await this.loadCountries()
    let savedFilters = localStorage.getItem('filters')
    if (savedFilters) {
      savedFilters = JSON.parse(savedFilters)
      if (paramServer) {
        this.servers = paramServer
      } else if (savedFilters.server) {
        this.server = savedFilters.server
      }
      if (paramCountry) {
        this.country = paramCountry
      } else if (savedFilters.country) {
        this.country = savedFilters.country
      }
      if (paramCity) {
        this.city = paramCity
      } else if (savedFilters.city) {
        this.city = savedFilters.city
      }
      if (paramArea) {
        this.area = paramArea
      } else if (savedFilters.area) {
        this.area = savedFilters.area
      }
    }
    this.updateCities()
    this.updateAreas()
    this.filtersChanged()
  },

  methods: {
    filtersChanged() {
      const filters = { server: this.server, country: this.country, city: this.city, area: this.area }
      let query = {}
      if (this.server) {
        query.server = this.server
      }
      if (this.country) {
        query.country = encodeURIComponent(this.country)
      }
      if (this.city) {
        query.region = encodeURIComponent(this.city)
      }
      if (this.area) {
        query.area = encodeURIComponent(this.area)
      }
      this.$router.replace({name: '', query}).catch(err => {})
      localStorage.setItem('filters', JSON.stringify(filters))
      this.$emit('change', filters)
    },

    countryChanged() {
      this.updateCities()
      this.filtersChanged()
    },

    cityChanged() {
      this.updateAreas()
      this.filtersChanged()
    },

    async updateCities() {
      this.city = ''
      this.area = ''
      this.areas = []
      if (this.country) {
        const countryCode = this.countries.find(country => country.name === this.country).code
        const citiesRef = await db.collection('cities').doc(countryCode).get()
        const citiesSnap = citiesRef.data()
        this.cities = citiesSnap.cities
      } else {
        this.cities = []
      }
    },

    async updateAreas() {
      this.area = ''
      this.areas = []
      if (this.city) {
        const areasRef = await db.collection('areas').doc(this.city).get()
        if (areasRef.empty) {
          this.areas = []
        } else {
          const areasSnap = areasRef.data()
          this.areas = areasSnap.areas
        }
      } else {
        this.areas = []
      }
    },

    async loadCountries() {
      const countriesRef = await db.collection('countries').doc('countries').get()
      const countryList = countriesRef.data()
      if (countryList) {
        this.countries = countryList.countries
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  border-top: 1px solid var(--text-color);
  border-bottom: 1px solid var(--text-color);
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  &__block {
    display: flex;
    align-items: center;
    min-width: 0;
    border-top: 1px solid var(--text-color);
    border-bottom: 1px solid var(--text-color);

    @media (min-width: 768px) {
      flex: 0 0 33.3%;
      border: none;
      .filters--with-areas & {
        flex: 0 0 25%;
      }
    }

    &:focus-within {
      background-color: #AAD9F6;
      color: #fff;
    }
  }

  &__icon {
    font-size: 24px;
    line-height: 1;
    margin-right: 8px;
    margin-left: 8px;
  }

  &__input {
    padding: 10px 0;
    background-color: transparent;
    flex-grow: 1;
    font-size: 18px;
    display: block;
    min-width: 0;
    border: none;

    &:focus {
      outline: none;
    }
  }
}
</style>